import React from 'react';
import Typography from '@material-ui/core/Typography';
import "./goals-card.scss";
import { Card, CardContent } from '@material-ui/core';


  
  export default function GoalsCard({goalsDesc}) {
  
    return (
    <div className="goals-card">
            
            <Card className="goals-card-mycard">
                    <CardContent>
                        <Typography  variant="h5" component="h2">
                            {goalsDesc}
                        </Typography>
                    </CardContent>
                    
            </Card>
               
          
               
    </div>
    );
  }